import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from './../../assets/icons/skip-left-all.png'
import _imports_1 from './../../assets/icons/skip-left.png'
import _imports_2 from './../../assets/icons/skip-right.png'
import _imports_3 from './../../assets/icons/skip-right-all.png'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  style: {"padding":"0px","margin-right":"0px","margin-left":"10px"},
  slot: "end"
}
const _hoisted_3 = {
  key: 1,
  style: {"display":"flex","justify-content":"space-between","width":"100%","white-space":"nowrap"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_header, { style: {"background-image":"linear-gradient(to bottom, rgb(110, 222, 174), white)"} }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_title, { style: {"font-size":"22px","text-align":"left"} }, {
            default: _withCtx(() => [
              _createTextVNode("Arrivals Today")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          (_ctx.dataArray.length <= 0)
            ? (_openBlock(), _createBlock(_component_ion_label, {
                key: 0,
                style: {"display":"flex","justify-content":"center","font-weight":"700"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("No Arrivals Today")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dataArray.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataArray, (item, index) => {
                  return (_openBlock(), _createBlock(_component_ion_list, {
                    key: index,
                    value: item,
                    style: {"padding":"0px","margin":"0px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { lines: "full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_grid, { style: {"padding":"0px","margin":"0px","padding-bottom":"8px","padding-top":"8px","width":"100%"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { style: {"padding":"0px","margin":"0px"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_row, { style: {"padding":"1px","margin":"0px","width":"100%"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { style: {"overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.dataArray[index].reservation.guest_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_row, { style: {"padding":"1px","margin":"0px"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { style: {"font-size":"smaller","font-weight":"500","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","width":"100%"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.dataArray[index].property_name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_ion_icon, {
                              class: "ldx-large-icon",
                              onClick: ($event: any) => (_ctx.openModal(_ctx.dataArray[index].reservation.id.toString())),
                              icon: _ctx.ellipsisVerticalOutline,
                              style: {"margin-top":"6px","cursor":"pointer"}
                            }, null, 8, ["onClick", "icon"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128)),
                (_ctx.dataArray.length >= 8 || _ctx.listSize >= 8)
                  ? (_openBlock(), _createBlock(_component_ion_label, {
                      key: 0,
                      style: {"display":"flex","justify-content":"center","padding-top":"8px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.offset + 1) + " to " + _toDisplayString(_ctx.dataArray.length + _ctx.offset) + " of " + _toDisplayString(_ctx.dataCount), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataArray.length >= 8 || _ctx.listSize >= 8)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toStart())),
                          color: "primary",
                          style: {"--border-radius":"10px","max-width":"50px","max-height":"50px","width":"100%","height":"100%"},
                          size: "default"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backButton())),
                          color: "primary",
                          style: {"--border-radius":"10px","max-width":"50px","max-height":"50px","width":"100%","height":"100%"},
                          size: "default"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextButton())),
                          color: "primary",
                          style: {"--border-radius":"10px","max-width":"50px","max-height":"50px","width":"100%","height":"100%"},
                          size: "default"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toEnd())),
                          color: "primary",
                          style: {"--border-radius":"10px","max-width":"50px","max-height":"50px","width":"100%","height":"100%"},
                          size: "default"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}